import React from "react";

const Select = ({ children, ...props }) => (
  <select
    className="rounded-tr-lg rounded-bl-lg border border-gray-1100 w-full bg-white px-15px"
    style={{
      paddingTop: "11px",
      paddingBottom: "12px",
      lineHeight: "20.8px",
      maxWidth: "390px",
      fontSize: "16px",
    }}
    {...props}
  >
    {children}
  </select>
);

export default Select;
